import { History } from 'history'

import { EmployeeResponse } from 'core/application/companies/getEmployees'
import CompanyUserStatus from 'core/domain/companies/CompanyUserStatus'
import companyUserStatus from 'core/domain/companies/CompanyUserStatus'

import { Button, Icon, Menu, MenuDivider, MenuItem } from 'common/components'
import { ROUTE_PATHS } from 'common/routePaths'

const menu = (
  record: EmployeeResponse,
  inviteEmployees: (record: EmployeeResponse, eligible: boolean, translate: any) => Promise<void>,
  translate: any,
  history: History<unknown>,
  renewalYear: number,
  displayResendRenewalNotice: boolean,
  onTerminateClicked?: (user: EmployeeResponse) => void,
  onOptInOptOutUserClicked?: (user: EmployeeResponse, type: string) => void,
  onResendNoticeClicked?: (user: EmployeeResponse) => void,
  refreshTable?: () => Promise<void>,
  onEditUsernameClicked?: (user: EmployeeResponse) => void,
): JSX.Element => {
  return (
    <Menu>
      <MenuItem key={1} onClick={() => history.push(`${ROUTE_PATHS.MANAGE_PEOPLE}/edit/${record.id}`)}>
        <div className="flex ai-center p-4">
          <Icon type="fas fa-pencil" className="mr-8 mt-4" />
          Edit
        </div>
      </MenuItem>
      {(record.canBeInvited || record.canBeReInvited) && (
        <MenuItem
          key={2}
          onClick={async () => {
            await inviteEmployees(record, true, translate)
            refreshTable()
          }}
        >
          <div className="flex ai-center p-4">
            <Icon type="fa fa-send" className="mr-8 mt-4" />
            {record.canBeInvited && 'Invite'}
            {record.canBeReInvited && 'Resend invite'}
          </div>
        </MenuItem>
      )}
      {record.canOptIn && (
        <MenuItem key={3} onClick={() => onOptInOptOutUserClicked(record, 'optIn')}>
          <div className="flex ai-center p-4">
            <Icon type="fa fa-check-circle" className="mr-8 mt-4" />
            Opt-in
          </div>
        </MenuItem>
      )}
      {record.canOptOut && (
        <MenuItem key={4} onClick={() => onOptInOptOutUserClicked(record, 'optOut')}>
          <div className="flex ai-center p-4">
            <Icon type="fa fa-times-circle" className="mr-8 mt-4" />
            Opt-out
          </div>
        </MenuItem>
      )}
      {displayResendRenewalNotice && (
        <MenuItem key={5} className="resend_notice" onClick={async () => onResendNoticeClicked(record)}>
          <div className="flex ai-center p-4">
            <Icon type="fa fa-send" className="mr-8 mt-4" />
            Resend {renewalYear} Notice
          </div>
        </MenuItem>
      )}
      {/*{record?.username && (*/}
      {/*  <MenuItem*/}
      {/*    key={5}*/}
      {/*    onClick={async () => {*/}
      {/*      if (onEditUsernameClicked) {*/}
      {/*        onEditUsernameClicked(record)*/}
      {/*      }*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    <div className="flex ai-center p-4">*/}
      {/*      <Icon type="fa fa-pencil" className="mr-8 mt-5" />*/}
      {/*      {translate('admin-dashboard.manage-people.edit-username-label')}{' '}*/}
      {/*    </div>*/}
      {/*  </MenuItem>*/}
      {/*)}*/}
      <MenuDivider />

      <MenuItem
        key={6}
        className="terminate_action"
        onClick={async () => {
          if (onTerminateClicked) {
            onTerminateClicked(record)
          }
        }}
      >
        {translate('admin-dashboard.manage-people.view-employee.terminate-button')}
      </MenuItem>
    </Menu>
  )
}

export default menu
